<template>
    <BModal
        :model-value="modal"
        centered
        @update:modelValue="updateModal"
        scrollable
        no-close-on-backdrop
        no-close-on-esc
    >
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Activity</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Destination *"
                        label-for="destination"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.destination"
                            label="name"
                            :options="destinationList"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select Destination"
                            :loading="destinationLoading"
                            @open="getAllDestination"
                            @option:selecting="getAllActivity"
                            :class="{
                                'is-invalid':
                                    v$.form.destination_uuid.$dirty &&
                                    v$.form.destination_uuid.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.destination_uuid.$dirty &&
                                v$.form.destination_uuid.$invalid
                            "
                        >
                            {{ v$.form.destination_uuid.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Activity"
                        label-for="activity"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="selectedActivity"
                            label="name"
                            :get-option-label="(item) => `${item.name} (${item.pax} pax)`"
                            @option:selected="getActivity"
                            :options="activityList"
                            :loading="activityLoading"
                            :reduce="(item) => item.uuid"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select Activity"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name"
                            type="text"
                            id="name"
                            placeholder="Enter Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty &&
                                    v$.form.name.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name.$dirty && v$.form.name.$invalid
                            "
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Description"
                        label-for="description"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.description"
                            type="text"
                            id="description"
                            :rows="5"
                            placeholder="Enter Description"
                            :class="{
                                'is-invalid':
                                    v$.form.description.$dirty &&
                                    v$.form.description.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.description.$dirty &&
                                v$.form.description.$invalid
                            "
                        >
                            {{ v$.form.description.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Pax *"
                        label-for="pax"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.pax"
                            type="number"
                            id="pax"
                            placeholder="Enter Pax"
                            @update:modelValue="calculateSubtotal"
                            :class="{
                                'is-invalid':
                                    v$.form.pax.$dirty && v$.form.pax.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="v$.form.pax.$dirty && v$.form.pax.$invalid"
                        >
                            {{ v$.form.pax.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Price per Pax "
                        label-for="price"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.price"
                            type="number"
                            id="price"
                            placeholder="Enter Price"
                            @update:modelValue="calculateSubtotal"
                            :class="{
                                'is-invalid':
                                    v$.form.price.$dirty &&
                                    v$.form.price.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.price.$dirty && v$.form.price.$invalid
                            "
                        >
                            {{ v$.form.price.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Subtotal"
                        label-for="sub_total"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.sub_total"
                            type="number"
                            id="sub_total"
                            placeholder="Subtotal"
                            @update:modelValue="calculatePrice"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Inclusion"
                        label-for="inclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.inclusion"
                            id="inclusion"
                            placeholder="Enter Inclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.inclusion.$dirty &&
                                    v$.form.inclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.inclusion.$dirty &&
                                v$.form.inclusion.$invalid
                            "
                        >
                            {{ v$.form.inclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Exclusion"
                        label-for="exclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.exclusion"
                            id="exclusion"
                            placeholder="Enter Exclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.exclusion.$dirty &&
                                    v$.form.exclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.exclusion.$dirty &&
                                v$.form.exclusion.$invalid
                            "
                        >
                            {{ v$.form.exclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormTextarea,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { parseRupiah } from "@/utils/format";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
    defaultPax: Number,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    selectedActivity.value = null;
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

let selectedActivity = ref(null);

const formData = {
    uuid: "",
    destination_uuid: "",
    destination: "",
    name: "",
    description: "",
    pax: 1,
    price: "",
    sub_total: "",
    inclusion: "",
    exclusion: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            const activityData = {
                ...newData,
                destination_uuid: newData.destination?.uuid || null,
                price: parseRupiah(newData.price),
            };
            Object.assign(form, { ...activityData });
        } else {
            Object.assign(form, { ...formData, pax: props.defaultPax || 1 });
            // Initial calculation if needed
            if(form.pax && form.price) calculateSubtotal();
        }
    },
    { immediate: true }
);

// Watch for defaultPax changes from parent (formProgram.pax)
watch(
    () => props.defaultPax,
    (newPax) => {
        // Only update if not editing existing data and pax is different
        if ((!props.selectedData || Object.keys(props.selectedData).length === 0) && newPax) {
            form.pax = newPax;
            calculateSubtotal();
        }
    }
);

const rules = {
    form: {
        destination: {
            required: helpers.withMessage("Destination is required", required),
        },
        destination_uuid: {
            required: helpers.withMessage("Destination is required", required),
        },
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        description: {},
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        price: {},
        sub_total: {},
        inclusion: {},
        exclusion: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.index != undefined ? update() : create();
};

const create = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            // Jka ada index hapus, index hanya jika edit
            const payload = { ...form };
            delete payload.index;
            emit("addOrUpdate", payload);
            toast.success("Activity added successfully");
            updateModal(false);
            resetForm();
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            emit("addOrUpdate", {
                index: props.selectedData.index,
                ...form,
            });
            toast.success("Activity updated successfully");
            updateModal(false);
            resetForm();
        } finally {
            loader.hide();
        }
    }
};

let destinationList = ref([]);
let destinationLoading = ref(false);

const getAllDestination = async () => {
    if (destinationList.value.length > 0) return;
    destinationLoading.value = true;
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        destinationLoading.value = false;
    }
};

// const activityFilteredList = computed(() => {
//     if (!form.pax) return activityList.value;
//     return activityList.value.filter(
//         (item) => item.pax == form.pax
//     );
// });

let activityList = ref([]);
let activityLoading = ref(false);
const getAllActivity = async (destination) => {
    activityLoading.value = true;
    form.destination = destination;

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/activity`,
            {
                params: {
                    destination_uuid: destination.uuid,
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            selectedActivity.value = null;
            activityList.value = res.data && res.data.length ? res.data : [];
        }
    } finally {
        activityLoading.value = false;
    }
};

const getActivity = (activity) => {
    if (activity) {
        form.name = activity.name;
        form.description = activity.description;
        form.pax = activity.pax;
        form.price = activity.price ?? 0;
        form.sub_total = activity.sub_total ?? 0;
        form.description = activity.description;
        form.inclusion = activity.inclusion;
        form.exclusion = activity.exclusion;
    } else {
        form.name = "";
        form.description = "";
        form.pax = "";
        form.price = "";
        form.sub_total = "";
        form.description = "";
        form.inclusion = "";
        form.exclusion = "";
    }
};

watch(
    () => form.destination,
    (val) => {
        form.destination_uuid = val ? val.uuid : null;
    }
);

const calculateSubtotal = () => {
    if (form.pax && form.price) {
        form.sub_total = form.pax * form.price;
    } else {
        if (!form.pax || !form.price) {
            form.sub_total = 0;
        }
    }
};

const calculatePrice = () => {
    if (form.pax && form.pax != 0 && form.sub_total) {
        form.price = Math.round(form.sub_total / form.pax);
    } else if (form.pax == 0 && form.sub_total) {
        // can't divide by zero
    } else {
        if (!form.sub_total) {
            form.price = 0;
        }
    }
};
</script>
